import React, { useEffect, useReducer } from "react";
import { logAccountCreated } from "components/payments/util";
import LcFetch from "lib/shared/fetch";
import FullUserForm from "components/payments/FullUserForm";
import SignUpPaymentForm from "components/payments/SignUpPaymentForm";
import GdprUserForm from "components/payments/GdprUserForm";

function reducer(state, action) {
  switch (action.type) {
    case "payment_step":
      return {
        ...state,
        clientSecret: action.clientSecret,
        step: "payment_step"
      };
    case "gdpr_user_step":
      return { ...state, step: "gdpr_user_step" };
    default:
      return state;
  }
}

export function RegistrationForm(props) {
  const {
    clientSecret,
    countries,
    countryCode,
    isGdprCountry,
    paypalEnvironment,
    requests,
    step,
    subscriptionType,
    validateUserPath
  } = props;

  // I'm pulling these off separately because they are only used in test.
  // If they're undefined, the real elements will be used, but if components
  // are passed in, we can render a slightly different version of this component
  // to use in Capybara tests without actually talking to either Stripe or Paypal.
  const { PaypalButton, StripePaymentElement } = props;

  const [state, dispatch] = useReducer(reducer, {
    clientSecret,
    step,
    subscriptionType
  });
  const showFinishAndPay =
    state.step === "payment_step" || state.step === "skip_to_payment";
  const sectionTitle = showFinishAndPay ? "Finish & Pay" : "Create Account";

  useEffect(() => {
    (async function () {
      // Create a free tier user, then go to payment
      if (step === "skip_to_payment") {
        const response = await requests.createFreeTierUser(subscriptionType);
        const data = await response.json();
        logAccountCreated(data.user_analytics);
        dispatch({
          clientSecret: data.stripe_client_secret,
          type: "payment_step"
        });
      }
    })();
  }, []);

  const formFromStep = () => {
    switch (state.step) {
      case "payment_step":
        return (
          <SignUpPaymentForm
            clientSecret={state.clientSecret}
            dispatch={dispatch}
            paymentError={state.paymentError}
            paypalEnvironment={paypalEnvironment}
            subscriptionType={state.subscriptionType}
            PaypalButton={PaypalButton}
            StripePaymentElement={StripePaymentElement}
          />
        );
      case "gdpr_user_step":
        return (
          <GdprUserForm
            subscriptionType={subscriptionType}
            countries={countries}
            countryCode={countryCode}
            dispatch={dispatch}
            isGdprCountry={isGdprCountry}
            validateUserPath={validateUserPath}
          />
        );
      case "skip_to_payment":
        // We initially return null. Once the useEffect fires and creates a new user and returns the Stripe
        // SetupIntent ID, we can progress to the payment form
        return null;
      default:
        // user registration
        return (
          <FullUserForm
            countries={countries}
            countryCode={countryCode}
            dispatch={dispatch}
            isGdprCountry={isGdprCountry}
            subscriptionType={subscriptionType}
            validateUserPath={validateUserPath}
          />
        );
    }
  };

  return (
    <div id="registration-form">
      <div className="signup-subscribe-form__title title-4">{sectionTitle}</div>
      <div className="pay-step" data-testid="pay-step">
        {formFromStep()}
      </div>
    </div>
  );
}

const requests = {
  createFreeTierUser: (subscriptionType = null) => {
    const fetchParams = {
      body: JSON.stringify({
        subscription: subscriptionType,
        user: { email_marketing_optin: true, simplified_signup: true }
      }),
      method: "POST"
    };
    return LcFetch("/", fetchParams);
  }
};

export default function (props) {
  return <RegistrationForm {...props} requests={requests} />;
}
